// @ts-expect-error - currency_helper is a JavaScript file without type declarations
import { CurrencyHelper } from "~/helpers/currency_helper"
import { SearchInput } from "~/react/ui/search-input"
import { Skeleton } from "~/react/ui/skeleton"
import { Alert, AlertContent } from "~/react/ui/alert"
import {
  FiltersDropdown,
  FiltersTags,
  type EmailAccountFilters,
  type TeamMember,
} from "~/react/components/email_accounts/email_accounts_filters"

type TableToolbarProps = {
  totalCount: number
  filters: EmailAccountFilters
  setFilters: React.Dispatch<React.SetStateAction<EmailAccountFilters>>
  teamMembers?: TeamMember[]
  sharedWorkspace: boolean
  loading?: boolean
  error?: string | null
}

export function TableToolbar({
  totalCount,
  filters,
  setFilters,
  teamMembers,
  sharedWorkspace,
  loading = false,
  error = null,
}: TableToolbarProps) {
  return (
    <div className="main-heading">
      <h2 className="main-heading__count">
        {loading ? (
          <Skeleton size="freeform" style={{ width: "10.4rem", height: "1.6rem" }} />
        ) : (
          <span
            dangerouslySetInnerHTML={{
              __html: i18n.t("js.email_accounts_center.count_html", {
                pretty_count: CurrencyHelper.numberWithDelimiter(totalCount),
                count: totalCount,
              }),
            }}
          />
        )}
      </h2>

      {!loading && (
        <>
          <hr className="main-heading__separator" />

          {error && (
            <Alert variant="destructive" className="mt-3">
              <AlertContent>{i18n.t("js.email_accounts_center.errors.alert")}</AlertContent>
            </Alert>
          )}

          <div className="main-heading__filtering">
            <SearchInput
              value={filters.searchQuery || ""}
              onChange={(value) => setFilters((prev) => ({ ...prev, searchQuery: value }))}
              placeholder={i18n.t("js.email_accounts_center.search_placeholder")}
              ariaLabel={i18n.t("js.email_accounts_center.search_aria")}
              clearAriaLabel={i18n.t("js.email_accounts_center.clear_search")}
            />
            <FiltersDropdown
              filters={filters}
              setFilters={setFilters}
              teamMembers={teamMembers}
              sharedWorkspace={sharedWorkspace}
            />
          </div>
        </>
      )}
    </div>
  )
}

type TableFilterTagsProps = {
  filters: EmailAccountFilters
  setFilters: React.Dispatch<React.SetStateAction<EmailAccountFilters>>
  teamMembers?: TeamMember[]
  sharedWorkspace: boolean
}

export function TableFilterTags({ filters, setFilters, teamMembers, sharedWorkspace }: TableFilterTagsProps) {
  return (
    <FiltersTags
      filters={filters}
      setFilters={setFilters}
      teamMembers={teamMembers}
      sharedWorkspace={sharedWorkspace}
    />
  )
}
